const Preloader = () => {
  return (
    <div>
      Loading...
    </div>
  );
};

export default Preloader;